import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useLevelsState = () => React.useContext(Context) || {}
export const useLevels = () => useLevelsState()?.levels || []

const QUERY = gql`
  query Levels($filter: LevelFilter) {
    levels(filter: $filter, sort: { field: ID, type: ASC }) {
      id
      name
      enabled
    }
  }
`

const LevelsLoader = ({ children, type }) => {
  const { data, fetchMore, variables, ...state } = useQuery(QUERY, {
    variables: { filter: { types: [type] } },
    client: placesClient,
    fetchPolicy: 'cache-first'
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state}>{children}</StatePresenter>
    </Provider>
  )
}

export default LevelsLoader
